import { render, staticRenderFns } from "./PokerTable.vue?vue&type=template&id=806173a6&scoped=true&"
import script from "./PokerTable.vue?vue&type=script&lang=js&"
export * from "./PokerTable.vue?vue&type=script&lang=js&"
import style0 from "./PokerTable.vue?vue&type=style&index=0&id=806173a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806173a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VCard,VCardText,VMain})
